import { darkOrange, warmTint } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import styled from 'styled-components'

/** The media frame: a rounded box that clips its image and centers a fallback icon. */
export const ThumbFrame = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${warmTint};
	color: ${darkOrange};
	border-radius: ${radii.inner};
	overflow: hidden;
	flex-shrink: 0;
`

export const ThumbImg = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
`
